const initPdfWorker = () => {
  return new Worker(new URL("pdfjs-dist/legacy/build/pdf.worker.mjs", import.meta.url), { type: "module" });
}

export { initPdfWorker }
